"use client";

import { TimelineContainer } from "./timeline-container";
import { HotelItineraryInner } from "./hotel-itinerary-inner";
import { iAccommodationLegDetails } from "@/@sdk/holiday-quotes-x/holiday-quotes-x-model";
import { useHolidayQuoteBrand } from "../contexts/use-holiday-quote-brand";
import { isTripMode } from "../trip-mode/partition-itinerary-for-trip-mode";

export function HotelItinerary(
  props: iAccommodationLegDetails & { primaryColor?: string; day: number }
) {
  const { quote } = useHolidayQuoteBrand();
  const showChrome = !isTripMode(quote?.data?.mode);

  return (
    <TimelineContainer
      title={props.title || "Hotel"}
      icon={(props.icon as any) || "hotel"}
      showChrome={showChrome}
    >
      <HotelItineraryInner {...props} day={props.day} />
    </TimelineContainer>
  );
}
